import Carousel from 'nuka-carousel';
import React, { useState } from 'react';
import UtilityButton from '../../shared/utilityButton/UtilityButton';
import { useEffect } from 'react';
import useMeasure from 'react-use-measure';
import './careersSection.scss';

import eurailImg from './../../assets/images/eurail.webp';
import ArgyllFerries from './../../assets/images/careers/ArgyllFerries.webp';
import Arriva from './../../assets/images/careers/Arriva.webp';
import C2C from './../../assets/images/careers/c2c.webp';
import LNER from './../../assets/images/careers/NatExpEastCoast.webp';
import ScotRail from './../../assets/images/careers/ScotRail.webp';
import GWR from './../../assets/images/careers/FirstGrtWest.webp';
import IRL from '../../assets/images/interlogo.webp';

const acelaexpress = 'carrier_logos/AMT/acelaexpress.webp';
const amtrak = 'carrier_logos/AMT/amtrak.webp'
const GWE = 'carrier_logos/ATOC/gatwickexpress.webp'
const HTE = 'carrier_logos/ATOC/heathrowexpress.webp'
const VIA = 'carrier_logos/VIA/viarail.webp'

const sncf = 'carrier_logos/SNCF/sncf.webp'
const thalys = 'carrier_logos/SNCF/thalys.webp'
const eurostar = 'carrier_logos/SNCF/eurostar.png'

const CareersSection = () => {
  const [ref, { width }] = useMeasure();
  const [smallScreen, setSmallScreen] = useState(false);

  const imagesPool = [
    { src: eurailImg, height: '50%' },
    { src: ArgyllFerries },
    { src: Arriva },
    { src: C2C },
    { src: LNER },
    { src: ScotRail },
    { src: GWR },
    { src: amtrak },
    { src: acelaexpress },
    { src: HTE },
    { src: GWE },
    { src: VIA },
    { src: sncf },
    { src: thalys },
    { src: eurostar },
    { src: IRL },
  ];

  useEffect(() => {
    if (width < 600) {
      setSmallScreen(true);
    } else {
      setSmallScreen(false);
    }
  }, [width])

  return (
    <div ref={ref} className="carrer-container">
      <div className="carrer-carousal max-width">
        <Carousel
          cellSpacing={12}
          slidesToShow={smallScreen ? 3 : 6}
          scrollMode="remainder"
          slidesToScroll={1}
          wrapAround
          framePadding={`${smallScreen ? '0 40px' : '0 100px'}`}
          autoplay
          renderCenterLeftControls={({ previousSlide }) => (
            <UtilityButton type="back" className="carrer-carousal--btn" onClick={previousSlide} ariaLabel="previous" />
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <UtilityButton type="forward" className="carrer-carousal--btn" onClick={nextSlide} ariaLabel="next" />
          )}
          defaultControlsConfig={{
            pagingDotsContainerClassName: 'carrer-carousal--dots'
          }}
        >
          {
            imagesPool.map((item, index) => (
              <div key={index} className="carrer-carousal--item">
                {
                  item.height ?
                    <img src={item.src} alt="eurail" />
                    : <img src={item.src} alt="eurail" />
                }
              </div>
            ))
          }
        </Carousel>
      </div>
    </div>
  );
}

export default CareersSection;
